<template>
  <div id="topicInfo" ref="topicInfos" class="topicInfo">
    <topBanner @headToApp="headToApp" :appName="appName" :topicInfo="topicInfo"></topBanner>
    <div v-if=" topicDetailType === 1">
      <div class="topicInfo_back" id="topicInfo_back"
           :style="styleComputed">
        <div class="topicInfo_head">
          <div class="topicInfo_text">
            <div class="topicInfo_title" v-html="parseSpace(topicInfo.title)"></div>
            <p v-html="parseSpace(topicInfo.description)"></p>
          </div>
          <div class="topicInfo_button" id="topicInfo_button" :class="{'cxjrbClass': showSubmit == 1}" >
            <!--<div v-if="attention" class="topicInfo_btn" @click="alertLogin">关注</div>-->
            <div v-if="attention" class="topicInfo_btn themeBgColor openappAndroidwx" @click="alertLogin">{{isAppName}}
            </div>
            <div v-if="attention === false" class="topicInfo_btn openappAndroidwx" @click="alertLogin">未关注</div>
          </div>
        </div>
      </div>
      <div v-if="alertShow" class="alert-modal">
        <div class="alert-hd">
          <div>请登录客户端！</div>
          <div class="alert-cancle" @click="alertCancle">取消</div>
          <div class="alert-sure openappAndroidwx" @click="alertSure">确定</div>
        </div>
      </div>
    </div>
    <div v-if="topicDetailType === 2"  class="topicDetailType2">
      <div v-if="this.bg" class="topicDetailType2-img">
        <img :src="`${this.bg.replace(/http:\/\/img\.newaircloud\.com/gi,'https://img.newaircloud.com')}`" alt="">
      </div>
    </div>
<!--  guǎng gào  -->
    <div v-if="1">
      <swiperAd :sid="sid" :topicID="topicID" :uid="uid"></swiperAd>
    </div>
<!-- See previous topics  -->
    <div class="previous-topics-main" v-if="topicInfo.isShowAllTopics == 1">
      <div class="previous-topics openappAndroidwx wx-launch-app-btn-parent" >
        <span>往期话题</span>
        <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4Ij48ZGVmcz48c3R5bGUgdHlwZT0idGV4dC9jc3MiPjwvc3R5bGU+PC9kZWZzPjxwYXRoIGQ9Ik02NzYuNTc5NTU2IDUxMS4yNjA0NDRsLTM5MC4yNTc3NzgtMzkwLjIyOTMzM2EyOC40NDQ0NDQgMjguNDQ0NDQ0IDAgMSAxIDQwLjI0ODg4OS00MC4yMjA0NDM5OUw3MzYuOTEwMjIxOTkgNDkxLjE1MDIyMmEyOC40NDQ0NDQgMjguNDQ0NDQ0IDAgMCAxIDFlLTggNDAuMjIwNDQ1TDMyNi41NzA2NjcgOTQxLjcxMDIyMjAxYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAwIDEtNDAuMjIwNDQ1LTQwLjIyMDQ0NDAxTDY3Ni41Nzk1NTYgNTExLjI2MDQ0NHoiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD48L3N2Zz4=" alt="">
      </div>
    </div>

    <div v-if=" topicDetailType === 1" class="topicInfo_foot">
      <div class="interest">
        <span v-if="topicInfo.interestCount>0">{{topicInfo.interestCount|parseCount}}人关注</span>
        <span v-if="topicInfo.topicCount>0" class="t-line"></span>
        <span v-if="topicInfo.topicCount>0">{{topicInfo.topicCount|parseCount}}参与 </span>
      </div>
      <div class="endTime">{{timeShow}}</div>
    </div>
    <div v-if="topicDetailType === 2"  class="topicDetailType2-head">
      <div class="topicDetailType2-title" v-html="parseSpace(topicInfo.title)"></div>
      <div class="topicDetailType2-status">
        <span style="margin-right: 0.3rem;" v-if="topicInfo.interestCount>0">{{topicInfo.interestCount|parseCount}}人关注</span>
        <!--          <span v-if="topicInfo.topicCount>0" class="t-line"></span>-->
        <!--          <span v-if="topicInfo.topicCount>0">{{topicInfo.topicCount|parseCount}}参与 </span>-->
        <span class="endTime">{{timeShow}}</span>
      </div>
      <div class="topicDetailType2-des" v-bind:class="{ topicDetailType2DesDown: showMoreDesClass }" v-if="topicInfo.description">
        <div class="des-content" v-html="parseSpace(topicInfo.description)"></div>
        <span v-if="showMoreDes" class="downArea" @click="showMoreDesChange()">
                <span class="arrowTip"><span></span></span>
            </span>
        <div style="height: 0;position:relative;">
          <div  ref="desBoxss" style="position:absolute;z-index: -11;visibility: hidden;" v-html="parseSpace(topicInfo.description)"></div>
        </div>

      </div>

    </div>
    <div v-if="showSubmit" id="submit-topic" style="width: 0;height: 0;">
      <div class="submit-topic openappAndroidwx wx-launch-app-btn-parent" :class="this.isWx && 'iswx'" @click="submitHref()" >
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAiCAMAAADiW5DOAAAAkFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+WABnwAAAAL3RSTlMA+8WArgXks1geGBDQyKGNFAz28OvClV86Jhzo4b65pmpIQCrbp6NTUALYfHdzM59y9XAAAAEjSURBVDjLjdHXkoJQEEXRbkBwSGZAzFkn7f//uwG1kCq4OOt5U4fqKzVBP5m5Y8aulfQDabPzlBf1do0iiygtZs7ZmbmUokzqegMFXae5POTpWkEHPakEM+A0l7r5GbCGVRKCu2/M75cQBs+h1f2DpqEFq8ecDdFI2owisO/DysKXdr6Llr+5gYuYXOFUpEokZhbqyxb6YtaHrTjoSMxGiiNHQukScpRx0XVxGAtspMuvpzLBk25bCfmUd2LwjcexqgP8iAE8DzBh2XvTyAC+3jXDKZqZm+qPpofmW1as51oRdTe3GOzOrcLHv5thEqeH8gw9Y7NbUNCJO9Hv9maQUONlr7d4NQpq5xc79tZObF99qVRNYbmXLjmwCaTTbTVNxewPF/YoLOzIc4wAAAAASUVORK5CYII="
          alt="">
        <span>我要参与</span>
      </div>
    </div>

<!--    <div class="topicDetailType2-des" style="">-->

<!--    </div>-->
  </div>
</template>

<script>
  import topBanner from '../topBanner'
  import utils from '../../tool/utils'
  import swiperAd from '../swiper/Adswiper'

  const _userAgent = window.navigator.userAgent
  const _agent = _userAgent.indexOf('xkyApp') === -1
  const _isMobile = _userAgent.indexOf('Android') > -1 || _userAgent.indexOf('Linux') > -1 || _userAgent.indexOf('iPhone') || /(Mobile)/gi.test(_userAgent)
  // eslint-disable-next-line no-useless-escape
  const _isWX = /MicroMessenger\/([\d\.]+)/i.test(_userAgent)

  export default {
    props: ['topicInfo', 'topicID', 'uid', 'bg', 'attention', 'themeColor', 'appName', 'sid', 'shareData'],
    data () {
      return {
        isAppName: '关注',
        downAppHref: '',
        alertShow: false,
        clientHeight: (window.innerWidth || screen.width || document.documentElement.clientWidth || document.body.clientWidth) / 16 * 9 * 2 / 100,
        showSubmit: 0,
        topicDetailType: /^(0|1|2)$/.test(this.$route.query.topicDetailType) ? +this.$route.query.topicDetailType : 2,
        showMoreDes: 0,
        showMoreDesClass: 0,
        isWx: _isWX
      }
    },
    beforeMount () {
    },
    components: {
      topBanner,
      swiperAd
    },
    created () {
      try {
        let str = this.topicInfo.endTime
        str = str && (str + '').replace(/-/g, '/')
          // eslint-disable-next-line eqeqeq
        this.showSubmit = (new Date(str).getTime() - new Date().getTime() > 0) && (_userAgent.indexOf('xkyApp') > -1 && (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') || _isWX) || 0
      } catch (e) {
        console.log(e)
      }
      if (this.appName && _agent) {
        // eslint-disable-next-line no-undef
        this.isAppName = `打开APP参与讨论`
      } else {
        this.isAppName = '关注'
      }
    },
    watch: {
      appName (newValue, oldValue) {
        // eslint-disable-next-line eqeqeq
        if (this.appName && _agent && newValue != oldValue) {
          this.appName = newValue
          // eslint-disable-next-line no-undef
          this.isAppName = `打开APP参与讨论`
        } else {
          this.isAppName = '关注'
        }
      },
      topicInfo (newValue, oldValue) {
        try {
          let str = this.topicInfo.endTime
          str = str && (str + '').replace(/-/g, '/')
          // eslint-disable-next-line eqeqeq
          this.showSubmit = (new Date(str).getTime() - new Date().getTime() > 0) && (_userAgent.indexOf('xkyApp') > -1 && (this.sid == 'cxjrb' || this.sid == 'xkycs' || this.sid == 'trrb') || _isWX) || 0
        } catch (e) {
          console.log(e)
        }
      }
    },
    mounted () {
      if (this.showMoreDes === 0) {
        if (this.$refs.desBoxss && this.$refs.desBoxss.offsetHeight && this.$refs.desBoxss.offsetHeight > 50) {
          this.showMoreDes = 1
        } else {
          this.showMoreDes = 0
        }
      }
    },
    beforeUpdate () {
    },
    updated () {
      if (this.showMoreDes === 0) {
        if (this.$refs.desBoxss && this.$refs.desBoxss.offsetHeight && this.$refs.desBoxss.offsetHeight > 50) {
          this.showMoreDes = 1
        } else {
          this.showMoreDes = 0
        }
      }
      // eslint-disable-next-line eqeqeq
      this.topicInfo.isShowAllTopics == 1 && utils.wxLaunchChange('.previous-topics-main', this.headToApp, '', 1, '', this.shareData)
      // 全局配置 开启app内跟帖
      // eslint-disable-next-line eqeqeq
      if (_isWX && this.showSubmit && this.topicInfo.config && this.topicInfo.config.h5CloseDiscuss == 1) {
        utils.wxLaunchChange('#submit-topic', this.headToApp, '', 1, '0.76rem', this.shareData)
      }
    },
    methods: {
      alertLogin (e) {
        if (_agent && _isMobile) {
          // window.location = this.downAppHref
          this.$emit('topicToApp')
        } else {
          this.alertShow = true
        }
      },
      alertCancle () {
        this.alertShow = false
      },
      alertSure (e) {
        this.$emit('topicToApp')
        this.alertShow = false
      },
      headToApp () {
        this.$emit('topicToApp')
      },
      submitHref () {
        // 全局配置 开启app内跟帖
        // eslint-disable-next-line eqeqeq
        if (_isWX && this.showSubmit && this.topicInfo.config && this.topicInfo.config.h5CloseDiscuss == 1) {
          console.log('关了')
          return
        }
        window.location.href = _isWX ? '/discussSubmit/' + this.topicID + '_' + this.sid + '.html' : 'jointopicdiscuss://?topicID=' + this.topicID + '&publishStatus=' + this.topicInfo.publishStatus
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      },
      showMoreDesChange: function () {
        console.log('showMoreDesChange', this.showMoreDesClass)
        this.showMoreDesClass = this.showMoreDesClass === 1 ? 0 : 1
      }
    },
    computed: {
      timeShow () {
        let str = this.topicInfo.endTime
        str = str && (str + '').replace(/-/g, '/')
        let curTime = new Date()
        const minuteTab = 60000
        const hourTab = 3600000
        const dateTab = 86400000
        const leadTime = new Date(str).getTime() - curTime.getTime()
        if ((leadTime > 3 * dateTab) || (leadTime < 0)) {
          if (leadTime < 0) {
            str = '已关闭'
          } else {
            str = ''
          }
        } else if (leadTime > 2 * dateTab) {
          str = '2天后关闭'
        } else if (leadTime > dateTab) {
          str = '1天后关闭'
        } else if (leadTime > hourTab) {
          let leadTimeHour = parseInt(leadTime / hourTab)
          str = `${leadTimeHour}小时后关闭`
        } else if (leadTime > minuteTab) {
          let leadTimeMinute = parseInt(leadTime / minuteTab)
          str = `${leadTimeMinute}分钟后关闭`
        }
        return str
      },
      styleComputed: function (e) {
        if (this.bg) {
          return {backgroundImage: `url( ${this.bg.replace(/http:\/\/img\.newaircloud\.com/gi, 'https://img.newaircloud.com')})`}
        }
      }
    },
    filters: {
      parseCount: function (t) {
        if (!t) return
        return utils.parseCount(t)
      }
    }
  }
</script>
<style>
  .topicInfo {
    position: relative;
    z-index: 2;
  }

  .topicInfo_back {
    width: 100%;
    height: 4.25rem;
    background: rgba(0, 0, 0, 0.4);
    z-index: 5;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    /*background-size: 100%;*/
    /*background-position: 0 0;*/
  }

  .topicInfo_head {
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-align: center;
    color: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .topicInfo_text {
    flex: 2.5;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .topicInfo_title {
    font-size: 0.34rem;
    font-weight: bold;
    text-shadow: 1px 1px 1px #333333;
    padding: 0 0.3rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .topicInfo_head p {
    font-size: 0.28rem;
    margin: 0.28rem 0.3rem 0 0.3rem;
    text-shadow: 1px 1px 1px #333333;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .topicInfo_button {
    /*width:1.13rem;*/
    margin: 0 auto;
    overflow: hidden;
    display: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 5rem;
  }

  .topicInfo_btn {
    /*width: 5rem;*/
    padding: 0 .3rem;
    min-width: 1.13rem;
    max-width: 5rem;
    height: 0.51rem;
    background-color: #13b7f6;
    color: #ffffff;
    font-size: 0.26rem;
    line-height: 0.26rem;
    padding-top: 0.125rem;
    border-radius: 0.3rem;
    overflow: hidden;
  }

  .topicInfo_foot {
    font-size: 0.24rem;
    color: #999999;
    background-color: #ededed;
    overflow: hidden;
    height: 0.5rem;
  }

  .interest {
    float: left;
    margin-left: 0.3rem;
    margin-top: 0.1rem;
  }

  .endTime {
    float: right;
    margin-right: 0.3rem;
    margin-top: 0.1rem;
  }

  .alert-modal {
    width: 100vw;
    height: 100vh;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
  }

  .alert-hd {
    width: 55vw;
    height: 28vw;
    background-color: #ffffff;
    margin: 5.5rem auto;
    font-size: 0.3rem;
    text-align: center;
    padding-top: 0.5rem;
    overflow: hidden;
  }

  .alert-sure, .alert-cancle {
    float: left;
    width: 1.2rem;
    height: 0.5rem;
    line-height: 0.5rem;
    background-color: #37de93;
    color: #ffffff;
    border-radius: 0.1rem;
    margin: 0.4rem auto;
  }

  .alert-cancle {
    margin: 0.4rem 0.5rem 0.3rem 0.62rem;
  }

  .topicInfo_foot .t-line {
    display: inline-block;
    height: 0.23rem;
    width: 0.01rem;
    background: #999999;
    margin: 0 0.05rem;
    vertical-align: middle;
  }

  .submit-topic {
    position: fixed;
    width: 2.66rem;
    height: 0.76rem;
    bottom: 0.56rem;
    right: 0;
    left: 0;
    margin: auto;
    padding: 0.21rem;
    font-size: 0.34rem;
    line-height: 1;
    text-align: center;
    border-radius: 0.76rem;
    color: #ffffff;
    background: var(--themeColor);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .submit-topic.iswx{
    bottom: 1.56rem;
  }
  .submit-topic img {
    display: inline-block;
    width: 0.35rem;
    height: 0.34rem;
    margin-right: 0.2rem;
  }
  .cxjrbClass{
    visibility: hidden;
  }
  .topicDetailType2{
    background: #fff;
    //border-bottom: 0.08rem solid #F6F6F6;
  }
  .topicDetailType2-head{
    padding: 0.2rem 0.3rem 0.34rem;
    background: #fff;
    border-bottom: 0.08rem solid #F6F6F6;
  }
  .topicDetailType2-img{
    width: 100%;
    height: 4.25rem;
  }
  .topicDetailType2-img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .topicDetailType2-title{
    font-size: 0.34rem;
    line-height: 0.57rem;
    margin-bottom: 0.115rem;
  }
  .topicDetailType2-status{
    font-size: 0.24rem;
    color: #999999;
    margin-bottom: 0.29rem;
  }
  .topicDetailType2-status .endTime{
    float: initial;
    margin: 0;
    //margin-left: 0.3rem;

  }
  .topicDetailType2-des{
    position: relative;
    font-size: 0.34rem;
    line-height: 0.48rem;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .topicDetailType2-des>div{

  }

  .moreListBtn{
    float: right;
    padding: 0 8px;
    font-size: 12px;
    color: #999999;
  }
  .arrowTip{
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid #999;
    border-radius: 50%;
    position: relative;
    vertical-align: middle;
  }
  .arrowTip span{
    display: block;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #999;
    border-bottom: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
  }
  .downArea{
    position: absolute;
    right: 0;
    bottom: 0;
    background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,1) 50%);
    padding-left: 30px;
  }
  .topicDetailType2DesDown {
    display: block;
    -webkit-box-orient: initial;
    -webkit-line-clamp: initial;
    overflow: initial;
  }
  .topicDetailType2DesDown .arrowTip{
    border-color:var(--themeColor);
  }
  .topicDetailType2DesDown .arrowTip span{
    border-bottom: 5px solid  var(--themeColor);
    border-top: none;
  }
  .topicDetailType2DesDown .downArea{
    position: relative;
    padding: 0;
    display: block;
    text-align: right;
    background:#ffffff;
  }
  .previous-topics{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 0.8rem;
    padding: 0 0.1rem 0 0.3rem;
    line-height: 1;
    background: linear-gradient(90deg, #FF7A47 0%, #F63711 100%);
  }
  .previous-topics span{
    font-size: 0.36rem;
    font-weight: normal;
    color: #FFFFFF;
  }
  .previous-topics img{
    height: 0.36rem;
  }

</style>



// WEBPACK FOOTER //
// head.vue?f8da4dd6